import React from 'react';
import {
  FieldsetWrapper,
  StyledFieldset,
  Heading,
  Label,
  TextInput,
  TextAreaLabel,
  TextArea,
  CheckboxWrapper,
} from './style';
import { Checkbox } from '../checkbox';

const Fieldset = ({ heading, children, disabled }) => (
  <FieldsetWrapper id="fieldset-wrapper" disabled={disabled}>
    <Heading>{heading}</Heading>
    <StyledFieldset>{children}</StyledFieldset>
  </FieldsetWrapper>
);

const FieldsetTextInput = ({ label, disabled, ...rest }) => (
  <Label>
    <span>{label}</span>
    <TextInput {...rest} disabled={disabled} />
  </Label>
);

const FieldsetCheckbox = ({ label, onChange, checked, ...rest }) => (
  <Label withCheckbox>
    <span>{label}</span>
    <CheckboxWrapper>
      <Checkbox onChange={onChange} checked={checked} {...rest} />
    </CheckboxWrapper>
  </Label>
);

const FieldsetTextArea = ({ ...rest }) => (
  <TextAreaLabel>
    <TextArea {...rest} />
  </TextAreaLabel>
);

Fieldset.TextInput = FieldsetTextInput;
Fieldset.TextArea = FieldsetTextArea;
Fieldset.Checkbox = FieldsetCheckbox;

export default Fieldset;



// WEBPACK FOOTER //
// ../shop_main/components/fieldset/index.js